import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {converterParaHoras} from '../../../../../../../../utils/date';


export interface VisualizaoPreCargaDistAutomatico {
  id?: number;
  destino?: string;
  qtdEntregas?: number;
  motorista?: string;
  veiculo?: string;
  valor?: number;
  volume?: number;
  peso?: number;
}

@Component({
  selector: 'rot-dialog-alerta-tempo-maximo-viagem-dist-automatico',
  templateUrl: './dialog-alerta-tempo-maximo-viagem-dist-automatico.component.html',
  styleUrls: ['./dialog-alerta-tempo-maximo-viagem-dist-automatico.component.scss']
})
export class DialogAlertaTempoMaximoViagemDistAutomaticoComponent implements OnInit {

  preCargasVisualizacao: VisualizaoPreCargaDistAutomatico[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public listaPreCargasNaoAtendeu: any,
              public dialog: MatDialogRef<DialogAlertaTempoMaximoViagemDistAutomaticoComponent>) {
    this.prepararObjetoVisualizacao();
  }

  ngOnInit() {
  }


  prepararObjetoVisualizacao() {
    this.preCargasVisualizacao = this.listaPreCargasNaoAtendeu.map(preCarga => {
      return {
        id: preCarga.id,
        destino: preCarga.destino,
        qtdEntregas: preCarga.listaEntregas.length,
        motorista: `${preCarga.motorista.id} - ${preCarga.motorista.nome}`,
        veiculo: `${preCarga.veiculo.id} - ${preCarga.veiculo.descricao} - ${preCarga.veiculo.placa}`,
        valor: preCarga.valor,
        volume: preCarga.volume,
        peso: preCarga.peso,
        preCargaDTO: preCarga.preCargaDTO,
        tempoMaximoViagem: preCarga.tempoMaximoViagem
      };
    });
  }

  podeProsseguir() {
    this.dialog.close(true);
  }

  naoPodeProsseguir() {
    this.dialog.close(false);
  }

  obterHorasExcedidoViagem(preCarga: any) {
    const cds = preCarga.preCargaDTO.solucao.vehicleRoutes[0].routes[0].activities.filter((activity) => activity.activity === 'LOADING');
    const dataSaidaCD: Date = new Date(cds[0].startDateTime);
    const dataRetornoCD: Date = new Date(cds[cds.length - 1].startDateTime);
    const diferencaMilissegundos: number = dataRetornoCD.getTime() - dataSaidaCD.getTime();
    const tempoViajando: number = diferencaMilissegundos / (1000 * 60 * 60);
    const tempoMaximoPermitido: number = converterParaHoras(preCarga.tempoMaximoViagem);
    const diferencaExcedida: number = tempoViajando - tempoMaximoPermitido;

    if (diferencaExcedida <= 0) {
      return `Nenhum tempo excedido. Tempo viajado: ${this.formatarHoras(diferencaExcedida)}.`;
    } else {
      return `Tempo excedido: ${this.formatarHoras(diferencaExcedida)}. <br> Tempo em viagem: ${this.formatarHoras(tempoViajando)}.<br> Tempo limite escolhido: ${this.formatarHoras(tempoMaximoPermitido)}.`;
    }
  }

  formatarHoras(tempo: number): string {
    const horas = Math.floor(tempo);
    const minutos = Math.round((tempo - horas) * 60);
    return `${horas} horas e ${minutos} minutos`;
  }
}
